<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">点数变更记录</span>
    </h2>
    <breadcrumb firstName="门店账户"></breadcrumb>
    <div class="scroll_container">
      <div class="handBar">
        <div class="pay__no">
          <common-input v-model="form.refSeqNo" placeholder="请输入">
            <template slot="before">
              <span>流水编号</span>
            </template>
          </common-input>
        </div>
        <div class="payno">
          <common-input v-model="form.prescriptionId" placeholder="请输入">
            <template slot="before">
              <span>处方单号</span>
            </template>
          </common-input>
        </div>
        <div class="selectPayType">
          <el-select v-model="form.detailType" clearable placeholder="类型" @change="form.subType = null">
            <el-option v-for="(label, item) in detailTypeOptions" :key="item" :label="label" :value="item"></el-option>
          </el-select>
        </div>
        <div class="selectPayType">
          <el-select v-model="form.subType" clearable placeholder="类型明细" :disabled="!form.detailType">
            <el-option
              v-for="(label, item) in subTypeOptions[form.detailType]"
              :key="item"
              :label="label"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <div class="SelectTime">
          <el-date-picker
            v-model="form.time"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="pickerOptions"
            class="zy-date-picker"
            :clearable="false"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
        <div class="showBtn" @click="showData()">
          <span>查看</span>
        </div>
        <div class="showBtn" @click="DownloadData()">
          <span>导出</span>
        </div>
      </div>
      <div class="table_container">
        <el-table
          stripe
          row-key="id"
          :data="tableData"
          size="medium"
          header-row-class-name="common-table-header"
          row-class-name="common-table-row"
          class="is-print-hide common-table"
          :border="true"
        >
          <el-table-column prop="id" label="流水编号">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="`${scope.row.id}`" placement="top">
                  <span>
                    {{ scope.row.id }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="consumeAmount" label="点数">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="scope.row.consumeAmount" placement="top">
                  <span>
                    {{ scope.row.consumeAmount }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="availableAmount" label="剩余点数">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="scope.row.availableAmount" placement="top">
                  <span>
                    {{ scope.row.availableAmount }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="consumePhone" label="账号">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="scope.row.consumePhone" placement="top">
                  <span>
                    {{ scope.row.consumePhone }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="consumeType" label="类型">
            <template slot-scope="scope">
              <span>{{ renderconsumeType(scope) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rechargeCoin" label="时间">
            <template slot-scope="scope">
              <div class="overbox">
                <el-tooltip effect="dark" :open-delay="500" :content="renderTime(scope)" placement="top">
                  <span>
                    {{ renderTime(scope) }}
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="coinAfterCharge" label="详细信息" min-width="266px">
            <template slot-scope="scope">
              <div class="coinAfterChargebox">
                <ul>
                  <li v-if="scope.row.consumeType == 8">转年费抵扣点数，已完成</li>
                  <template v-else-if="!scope.row.detailType">
                    <template v-if="scope.row.consumeType !== 16">
                      <li v-for="(item, index) in scope.row.storeCoinDetailBizList" :key="index">
                        处方单
                        <span @click="goDetail(item.bizId)">{{ item.bizId }}</span>
                        ，
                        <em>{{ renderbizStatus(item.prescriptionTotalStatus) }}</em>
                      </li>
                    </template>
                    <template v-else>
                      <span>转年费赠送点数失效，已完成</span>
                    </template>
                  </template>
                  <li v-else>
                    {{ handlerDetail(scope.row) }}
                  </li>
                </ul>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <skinny-pagination :page-no="form.pageNo" :is-end="isEnd" @on-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from '@/components/global/breadcrumb';
import commonInput from '@/components/global/form/common_input';
import { baseFormat } from '@fastweb/f2e-utils';
import { transformParamToUrl, downloadByIframe, isEmpty } from '@/util/index';
import SkinnyPagination from '@/components/skinnyPagination';
import Vue from 'vue';
import dayjs from 'dayjs';

export default {
  components: {
    breadcrumb,
    commonInput,
    SkinnyPagination
  },
  data() {
    return {
      form: {
        refSeqNo: null,
        prescriptionId: null,
        detailType: null,
        subType: null,
        time: [dayjs().subtract(6, 'days'), dayjs().endOf('day')],
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      tableData: [],
      detailTypeOptions: { 0: '消费', 1: '充值' },
      subTypeOptions: [
        { 0: '全部', 2: '图文咨询', 4: '视频咨询', 8: '抵扣' },
        { 0: '全部', 1: '线上充值', 2: '线下充值', 3: '赠送' }
      ],
      pickerOptions: {
        disabledDate: time => {
          const timestamp = time.getTime();
          const max = dayjs().endOf('day');
          if (timestamp <= +max.format('x')) {
            return false;
          }
          return true;
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick: picker => {
              const end = new Date(dayjs().endOf('day'));
              const start = new Date(dayjs().endOf('day'));
              console.log(start);
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 + 1);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近两周',
            onClick: picker => {
              const end = new Date(dayjs().endOf('day'));
              const start = new Date(dayjs().endOf('day'));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14 + 1);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近三周',
            onClick: picker => {
              const end = new Date(dayjs().endOf('day'));
              const start = new Date(dayjs().endOf('day'));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 21 + 1);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          },
          {
            text: '最近一个月',
            onClick: picker => {
              const end = new Date(dayjs().endOf('day'));
              const start = new Date(dayjs().endOf('day'));
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 + 1);
              picker.$emit('pick', [start, end]);
              this.showAllData();
            }
          }
        ]
      }
    };
  },
  computed: {
    isEnd() {
      return this.form.pageNo * this.form.pageSize >= this.form.totalCount;
    }
  },
  watch: {
    'form.time': {
      handler(value) {
        let [startDate, endDate] = value;
        console.log(new Date(startDate), new Date(endDate));
        if ((endDate - startDate) / 86400 / 1000 > 30) {
          startDate = endDate - 86400 * 29 * 1000;
          this.$message('查询时间不能超过30天');
          this.form.time = [startDate, endDate];
        }
      }
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/prescription/detail/${id}?mode=1`);
    },
    renderbizStatus(prescriptionTotalStatus) {
      if (prescriptionTotalStatus == 1) {
        return '待审核';
      }
      if (prescriptionTotalStatus == 2) {
        return '已完成';
      }
      if (prescriptionTotalStatus == 3) {
        return '已驳回';
      }
      if (prescriptionTotalStatus == 4) {
        return '已失效';
      }
    },
    handleDateRange([start, end]) {
      if (dayjs(end).diff(dayjs(start), 'days') > 30) {
        this.form.time = [start, +dayjs(start).add(30, 'days')];
      } else {
        this.form.time = [start, end];
      }
    },
    async DownloadData() {
      let res = await this._getData({ newQuery: 0 });
      if (this.form.totalCount > 20000) {
        this.$message({
          message: '此次导出数据超过2万条，请缩小查询范围后导出',
          type: 'error'
        });
      } else {
        const { detailType, subType } = this.form;
        const params = {
          prescriptionId: this.form.prescriptionId,
          id: this.form.refSeqNo,
          detailType,
          subType,
          consumeStartTime: this.formatStartTime(),
          consumeEndTime: this.JudgeprescriptionEndTime(),
          consumeType: this.form.consumeType == 99 ? null : this.form.consumeType,
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize
        };

        this.$store.dispatch('download/exportFile', { exportType: 'async_export_store_coin', ...params });
        // const baseUrl = `${Util.getGwRoot}drugstore/1.0/async_export_store_coin`;
        // const str = transformParamToUrl(params);
        // const openUrl = `${baseUrl}?${str}`;
        // downloadByIframe(openUrl, '点数消费记录');
      }
    },
    /**
     * @param {number} val -1 | 1
     * */
    handleCurrentChange(val) {
      this.form.pageNo = val;
      this._getData({ newQuery: 0 });
    },
    JudgeprescriptionEndTime() {
      // 后端要求获取当天数据时间戳需要+一天
      // 时间戳转年月日再转时间戳
      // return this.form.time[1] + 86400000;
      if (!this.form.time[1]) {
        return null;
      }
      return +dayjs(dayjs(this.form.time[1] + 86400000).format('YYYY-MM-DD')).format('x');
    },
    formatStartTime() {
      // 时间戳转年月日再转时间戳
      // return dayjs(this.form.time[0] * 1);
      if (!this.form.time[0]) {
        return null;
      }
      return +dayjs(dayjs(this.form.time[0] * 1).format('YYYY-MM-DD')).format('x');
    },

    renderTime(sc) {
      // 渲染支付时间
      let time = baseFormat(sc.row.consumeTime, 'YYYY-MM-DD HH:mm:ss');
      return time;
    },
    renderconsumeType(sc) {
      const { detailType, consumeType, rechargeType } = sc.row;
      return detailType
        ? { 1: '充值-线上充值', 2: '充值-线下充值', 3: '充值-点数赠送' }[rechargeType]
        : { 2: '消费-图文咨询', 4: '消费-视频咨询', 8: '消费-转年费抵扣点数', 16: '消费-赠送点数失效' }[consumeType];
    },
    handlerDetail({ remark, price, consumeAmount, rechargeType }) {
      if (rechargeType === 1) {
        return `充值金额${(price / 100).toFixed(2)}元`;
      } else if (rechargeType === 2) {
        return `线下充值${consumeAmount}点`;
      } else if (rechargeType === 3) {
        return remark;
      }
    },
    dealDisabledDate(time) {
      // 90天前跟今天后都不能选
      /* if (
        time.getTime() >
          dayjs()
            .subtract(0, 'days')
            .format('x') ||
        time.getTime() <
          dayjs()
            .subtract(90, 'days')
            .format('x')
      ) {
        return true;
      } */
    },
    showData() {
      this.form.pageNo = 1;
      this._getData({ newQuery: 1 });
    },
    showAllData() {
      // 时间选择器使用
      this.form.pageNo = 1;
      this._getData({ newQuery: 1 });
    },
    async _getData(opts = {}) {
      // detailType、subType都是字符串
      const { prescriptionId = null, detailType = null, subType = null, refSeqNo = null, pageNo, pageSize } = this.form;
      const params = {
        prescriptionId: prescriptionId,
        id: this.form.refSeqNo,
        consumeStartTime: this.formatStartTime() || null,
        consumeEndTime: this.JudgeprescriptionEndTime() || null,
        detailType: detailType ? Number(detailType) : null,
        subType: Number(subType) || null,
        pageNo,
        pageSize,
        status: 1, // 0已冻结，1已消费，2已解冻
        ...opts
      };
      Object.entries(params).forEach(([k, v]) => {
        isEmpty(v) && delete params[k];
      });
      let res = await Fetch.store_coin_detail_page(params);
      this.tableData = res.data;
      this.form.totalCount = res.totalCount * 1;
    }
  },
  mounted() {
    this._getData({ newQuery: 1 });
  }
};
</script>
<style lang="scss" scoped>
.coinAfterChargebox {
  li {
    span {
      color: #1e8dff;
      cursor: pointer;
    }
  }
}
.overbox {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.scroll_container {
  padding: 16px;
  box-shadow: 0px 4px 12px 0px rgba(237, 237, 237, 1);
  border-radius: 4px;
  border: 1px solid rgba(242, 242, 242, 1);
  background: #fff;
  .handBar {
    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .baseHandbars {
      float: left;
      margin-right: 16px;
      margin-bottom: 16px;
    }
    .pay__no {
      @extend .baseHandbars;
    }
    .payno {
      @extend .baseHandbars;
    }
    .selectPayType {
      @extend .baseHandbars;
    }
    .SelectTime {
      @extend .baseHandbars;
    }
    .showBtn {
      @extend .baseHandbars;
      float: left;
      cursor: pointer;
      background: #fff;
      color: #1e8dff;
      height: 40px;
      width: 80px;
      border: 1px solid #1e8dff;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      &:hover {
        background: rgba(68, 184, 91, 0.1);
      }
    }
  }
  .footer {
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 16px;
  }
}
</style>
